import React, { useState, useEffect, useMemo } from "react";
import "./Header.css";

const CHANGE_LETTERS = ["A", "I", "O", "E", "T", "S", "Z"];

const LETTER_MAP = {
  I: "1",
  A: "4",
  O: "0",
  E: "3",
  S: "5",
  T: "7",
  Z: "2",
  1: "I",
  4: "A",
  0: "O",
  3: "E",
  5: "S",
  7: "T",
  2: "Z",
};

const Header = (props) => {
  const textInput = props.text.toUpperCase();

  const changeIndexes = useMemo(() => {
    const indexes = [];
    for (let i = 0; i < textInput.length; i++) {
      if (CHANGE_LETTERS.includes(textInput.charAt(i))) {
        indexes.push(i);
      }
    }
    return indexes;
  }, [textInput]);

  const initialText = useMemo(() => {
    return textInput.split("").map((char) => (char === " " ? char : char.toUpperCase()));
  }, [textInput]);

  const [text, setText] = useState(initialText);
  const [seconds, setSeconds] = useState(1);

  useEffect(() => {
    setText(initialText);
  }, [initialText]);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(new Date().getTime() / 1000);
    }, 2000);
    return () => clearInterval(interval);
  }, [seconds]);

  useEffect(() => {
    if (changeIndexes.length === 0) return undefined;

    const timeouts = [];
    for (let index = 0; index < changeIndexes.length / 2; index++) {
      timeouts.push(
        setTimeout(() => {
          setText((prev) => {
            const randomIndex = Math.floor(Math.random() * changeIndexes.length);
            const letterIndex = changeIndexes[randomIndex];
            const letter = prev[letterIndex];
            const mapped = LETTER_MAP[letter];
            if (!mapped) return prev;
            const next = [...prev];
            next[letterIndex] = mapped;
            return next;
          });
        }, 2000)
      );
    }

    return () => timeouts.forEach(clearTimeout);
  }, [seconds, changeIndexes]);

  return (
    <div className="digital-anthropology-lab">
      <h1 id="center">{text}</h1>
    </div>
  );
};

export default Header;
